import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

// @mui material components
import Checkbox from "@mui/material/Checkbox";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import curved11 from "assets/images/curved-images/curved11.jpg";

import AuthApi from "../../../api/auth";

function EmailVerify() {
  const [agreement, setAgreement] = useState(true);
  const [formData, setFormData] = useState({
    'email': '',
    'verificationCode': ''
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSetAgreement = () => setAgreement(!agreement);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    AuthApi.Verify(formData).then(response => {
      setLoading(false);
      if (response.data && response.data.affected && response.data.affected > 0) {
        navigate("/authentication/first-login");
      } else {
        setError("Verification failed. Please try again.");
      }
    }).catch(error => {
      setLoading(false);
      setError("There has been an error.");
      console.error("Error during verification:", error);
    });
  };

  return (
    <CoverLayout
      title="Email verification"
      image={curved11}
      top={25}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={2} lineHeight={1.25}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Email
            </SoftTypography>
          </SoftBox>
          <SoftInput type="email" placeholder="Email" value={formData?.email} name="email" onChange={handleChange} />
        </SoftBox>
        <SoftBox mb={2} lineHeight={1.25}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Verification Code
            </SoftTypography>
          </SoftBox>
          <SoftInput type="password" placeholder="Verification code" value={formData?.verificationCode} name="verificationCode" onChange={handleChange} />
        </SoftBox>
        <SoftBox mt={2} mb={2} textAlign="center">
          <h6
            style={{
              fontSize: ".8em",
              color: "red",
              textAlign: "center",
              fontWeight: 400,
              transition: ".2s all",
            }}
          >
            {error}
          </h6>
        </SoftBox>
        <SoftBox mt={4} mb={1} textAlign="center">
          <SoftButton variant="gradient" color="info" onClick={handleSubmit} fullWidth disabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Verify my email'}
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </CoverLayout>
  );
}

export default EmailVerify;
